import { render } from "./scenePPM.vue?vue&type=template&id=916fc076"
import script from "./scenePPM.vue?vue&type=script&lang=js"
export * from "./scenePPM.vue?vue&type=script&lang=js"

import "./scenePPM.vue?vue&type=style&index=0&id=916fc076&lang=scss"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__